import { CrudState } from "@/store/Crud/State";

export class State extends CrudState {
  isLoadingCostBearer = false;
  dataItemCostBearer: Record<string, any> = {};
}
